import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { Reveal } from "@/components/Motion";

function Tile({ s, className }) {
  const Icon = s.icon;
  const hasPhoto = Boolean(s.image);
  return (
    <Link
      to={`/services#${s.slug}`}
      data-testid={`home-services-tile-${s.slug}`}
      className={`group relative flex h-full min-h-[220px] flex-col justify-end overflow-hidden rounded-2xl border border-white/10 bg-panel p-6 transition-colors duration-300 hover:border-white/25 ${className || ""}`}
    >
      {hasPhoto ? (
        <>
          <img
            src={s.image}
            alt={s.imageAlt || s.name}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/10" />
        </>
      ) : (
        <div
          aria-hidden
          className="absolute inset-0 opacity-[0.35]"
          style={{
            backgroundImage: "radial-gradient(rgba(224,122,95,0.25) 1px, transparent 1px)",
            backgroundSize: "18px 18px",
          }}
        />
      )}
      <div className="relative">
        <Icon className={`mb-3 h-6 w-6 ${hasPhoto ? "text-gold" : "text-ember"}`} aria-hidden />
        <h3 className="font-display text-lg font-bold tracking-tight text-white sm:text-xl">{s.name}</h3>
        <p className="mt-1.5 max-w-md text-[13px] leading-relaxed text-mist">{s.short}</p>
        <span className="mt-3 inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
          Explore
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden />
        </span>
      </div>
    </Link>
  );
}

export default function BentoServices() {
  const bySlug = Object.fromEntries(SERVICES.map((s) => [s.slug, s]));
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28" data-testid="home-services-bento">
      <Reveal>
        <p className="eyebrow mb-4">Everything we make</p>
        <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Seven ways to make something yours.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-4">
          <Tile s={bySlug["embroidery"]} className="md:col-span-2 md:row-span-2 min-h-[320px] md:min-h-[420px]" />
          <Tile s={bySlug["3d-printing"]} className="md:col-span-2" />
          <Tile s={bySlug["laser-engraving"]} />
          <Tile s={bySlug["sublimation"]} />
          <Tile s={bySlug["dtf-printing"]} className="md:col-span-2" />
          <Tile s={bySlug["custom-apparel"]} />
          <Tile s={bySlug["personalized-gifts"]} />
        </div>
      </Reveal>
    </section>
  );
}
